import { defineComponent as _defineComponent } from 'vue'
import { ref, useStore, watch, computed } from '@nuxtjs/composition-api';
import { State } from '~/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'Toast',
  setup(__props) {

const $store = useStore<State>();
const status = ref('');
const toast = computed(() => $store.getters.toast);
const timeToShowToast = 3000;

watch(toast, async () => {
  if (toast.value) {
    status.value = 'show';
    await dismissToast();
  }
});

const timeoutToast = (milliseconds: number) => {
  return new Promise(resolve => setTimeout(resolve, milliseconds));
};

const dismissToast = async () => {
  try {
    if (process.browser) {
      await timeoutToast(timeToShowToast);
    }
    await $store.dispatch('dismissToast');
    status.value = '';
  } catch (err) {
    console.error(err);
  }
};

return { __sfc: true,$store, status, toast, timeToShowToast, timeoutToast, dismissToast }
}

})